import { c as _c } from "react/compiler-runtime";
import Modal, { ModalContent, ModalHeader } from '../HOC/Modal';
type Props = {
  closeHandler: () => void;
};
const FoundersTokensTermsModal = t0 => {
  const $ = _c(13);
  const {
    closeHandler
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h2 className="text-xl font-semibold">Founders Tokens Terms of Service</h2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== closeHandler) {
    t2 = <ModalHeader closeHandler={closeHandler}>{t1}</ModalHeader>;
    $[1] = closeHandler;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="anim-enter [--enter-duration:300ms] [--enter-y:10px]"><h3 className="mb-2 text-lg font-semibold text-textPrimary">Important Terms and Conditions for Founders Tokens</h3><p className="mb-4">By purchasing Founders Tokens, you acknowledge and agree to the following terms and conditions. Please read these carefully before proceeding with your purchase.</p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="anim-enter rounded-lg border border-ds-border-standard bg-background-secondary p-4 [--enter-delay:100ms] [--enter-duration:300ms] [--enter-y:10px]"><h4 className="mb-2 font-semibold text-textPrimary">Non-Transferable Tokens</h4><p>Founders Tokens are strictly non-transferable and cannot be sold, gifted, traded, or transferred to any other person or entity under any circumstances. These tokens are permanently bound to your account and cannot be moved or reassigned.</p></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="anim-enter rounded-lg border border-ds-border-standard bg-background-secondary p-4 [--enter-delay:200ms] [--enter-duration:300ms] [--enter-y:10px]"><h4 className="mb-2 font-semibold text-textPrimary">No Sharing Permitted</h4><p>Founders Tokens and their associated benefits cannot be shared with others. This includes but is not limited to sharing account access, premium features, or any privileges granted through token ownership. Each token is intended for individual use by the original purchaser only.</p></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="anim-enter rounded-lg border border-ds-border-standard bg-background-secondary p-4 [--enter-delay:300ms] [--enter-duration:300ms] [--enter-y:10px]"><h4 className="mb-2 font-semibold text-textPrimary">Company Removal Policy</h4><p>Companies and organizations that utilize Founders Tokens may be subject to removal from the platform at Factiii's sole discretion. This includes but is not limited to cases where tokens are used in ways that violate our community guidelines or platform policies.</p></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="anim-enter rounded-lg border border-ds-border-standard bg-background-secondary p-4 [--enter-delay:400ms] [--enter-duration:300ms] [--enter-y:10px]"><h4 className="mb-2 font-semibold text-textPrimary">Anti-Abuse Protection</h4><p>Factiii reserves the right to remove, suspend, or revoke Founders Tokens if we determine they are being used in ways that abuse the system, violate our terms of service, or are deemed harmful to the platform or community. This determination is made at our sole discretion and may include but is not limited to misuse of premium features, violation of community standards, or any activity we deem inappropriate or harmful.</p></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="anim-enter rounded-lg border border-ds-border-standard bg-background-secondary p-4 [--enter-delay:400ms] [--enter-duration:300ms] [--enter-y:10px]"><h4 className="mb-2 font-semibold text-textPrimary">Final Authority</h4><p className="text-destructive">All decisions regarding the enforcement of these terms, including token removal, account suspension, or other disciplinary actions, are final and at the sole discretion of Factiii. We are not obligated to provide refunds in cases where tokens are removed due to violations of these terms.</p></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ModalContent><div className="max-h-96 space-y-4 overflow-y-auto text-sm text-textSecondary">{t3}{t4}{t5}{t6}{t7}{t8}<div className="anim-enter border-t border-ds-border-standard pt-4 [--enter-delay:600ms] [--enter-duration:300ms] [--enter-y:10px]"><p className="text-xs text-textSecondary">By proceeding with your Founders Token purchase, you acknowledge that you have read, understood, and agree to be bound by these terms and conditions. These terms are in addition to our standard Terms of Service and Privacy Policy.</p></div></div></ModalContent>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== closeHandler || $[11] !== t2) {
    t10 = <Modal closeHandler={closeHandler}>{t2}{t9}</Modal>;
    $[10] = closeHandler;
    $[11] = t2;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  return t10;
};
export default FoundersTokensTermsModal;